import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IMunicipio } from '../shared/interfaces/seguridad';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class MunicipioService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/municipio`;
  }

  getMunicipios(paisId: number, departamentoId: number): Observable<IMunicipio[]> {
    return this.http.get<IMunicipio[]>(`${this.baseUrl}/public/${paisId}/${departamentoId}`);
  }
}
